import { render, staticRenderFns } from "./pickup-points-add.vue?vue&type=template&id=50db8461&scoped=true&"
import script from "./pickup-points-add.vue?vue&type=script&lang=js&"
export * from "./pickup-points-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50db8461",
  null
  
)

export default component.exports